import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
    FormGroup,
    FormControlLabel,
    Checkbox, Typography
} from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../lib/axios';
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import axios from "../../../lib/axios";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from '../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'ChrgName', label: 'Charges Name', minWidth: 100 },
    { id: 'ChrAbvr', label: 'Abrv', minWidth: 100 },
    { id: 'Remarks', label: 'Remark', minWidth: 100 }
];

const OtherCharges = () => {
    const [formData, setFormData] = useState({
        ChrgName: '',
        ChrAbvr: '',
        Remarks: ''
    });

    const [error, setError] = useState({
        ChrgName: false,
        ChrAbvr: false
    });

    const navigate = useNavigate();
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const location = useLocation();
    const [currentOthChrgId, setCurrentOthChrgId] = useState(null);
    const [mode, setMode] = useState('view');
    const [Status, setStatus] = useState("1");
    const [LastInsertedChrgId, setLastInsertedChrgId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });

    const ChrgNameRef = useRef(null);
    const ChrAbvrRef = useRef(null);
    const RemarkRef = useRef(null);

    useEffect(() => {
        if (location.state && location.state.OthChrgId) {
            setCurrentOthChrgId(location.state.OthChrgId);
            fetchOtherCharges(location.state.OthChrgId, "R");
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location]);


    const fetchOtherCharges = async (id, flag) => {
        try {
            const response = await axiosInstance.post(`MstOthChrg/RetriveMstOthChrg`, {
                OthChrgId: parseInt(id),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1 && response.data.Data) {
                const ChargesData = Array.isArray(response.data.Data) ? response.data.Data[0] : response.data.Data;
                if (ChargesData) {
                    setFormData({
                        ChrgName: ChargesData.ChrgName || '',
                        ChrAbvr: ChargesData.ChrAbvr || '',
                        Remarks: ChargesData.Remarks || ''
                    });
                    setStatus(ChargesData.Status?.toString() || "0");
                    setIsFormDisabled(true);
                    setCurrentOthChrgId(ChargesData.OthChrgId);
                } else {
                    toast.error('No data found for the provided ID');
                }
            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
            } else {
                toast.error(response.data.Message || 'No data found for the provided ID');
            }
        } catch (error) {
            console.error('Error fetching other charges data:', error);
            toast.error('Error fetching other charges data. Please try again.');
        }
    };

    useEffect(() => {
        const getRow = async () => {
            const params = {
                start: 1,
                PageSize: 1,
                SearchText: ""
            };

            try {
                const res = await axios.post('MstOthChrg/GetMstOthChrgDashboard', { params });

                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                } else {
                    console.error('No data found in response');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };

        getRow();
    }, []);

    const handlePrevious = async () => {
        if (currentOthChrgId && currentOthChrgId > 1) {
            await fetchOtherCharges(currentOthChrgId, "P");
        }
    };

    const handleNext = async () => {
        if (currentOthChrgId) {
            await fetchOtherCharges(currentOthChrgId, "N");
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

        if (name === 'Floor') {
            setFormData(prevState => ({
                ...prevState,
                state: ''
            }));
        }

        if (name === 'Floor' && value !== '') {
            setTimeout(() => {
                RemarkRef.current.focus();
            }, 100000);
        }
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === ChrgNameRef.current) {
                ChrAbvrRef.current.focus();
            } else {
                RemarkRef.current.focus();
            }
        }
    };

    const handleSubmit = async () => {

        let hasError = false;

        if (!formData.ChrgName) {
            toast.error('Charges is required');
            setError(prev => ({ ...prev, ChrgName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, ChrgName: false }));
        }

        if (hasError) {
            return;
        }

        try {
            const payload = {
                ChrgName: formData.ChrgName,
                ChrAbvr: formData.ChrAbvr,
                Remarks: formData.Remarks,
                Status: Status
            };

            let response;
            if (mode === 'edit') {
                payload.OthChrgId = currentOthChrgId;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axiosInstance.patch(`MstOthChrg/UpdateMstOthChrg`, payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axiosInstance.post(`MstOthChrg/InsertMstOthChrg`, payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedChrgId(response.data.Data)
                    await fetchOtherCharges(response.data.Data);
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentOthChrgId(response.data.Data);
                } else {
                    setMode('view');
                }
                setIsFormDisabled(true);
            } else {
                toast.error(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            toast.error('Error saving/updating charges. Please try again.');
        }
    };

    const handleEdit = async () => {
        let Flag = await checkAndLock(currentOthChrgId, "MstOthChrg", "OthChrgId");
        switch (Flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default:
                toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            ChrgName: '',
            ChrAbvr: '',
            Remarks: ''
        });
        setCurrentOthChrgId(null);

        setTimeout(() => {
            ChrgNameRef.current.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            await fetchOtherCharges(1, "L");
            await UnLock(currentOthChrgId, "MstOthChrg", "OthChrgId");
            setStatus("1");
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    const resetForm = () => {
        setFormData({
            ChrgName: '',
            ChrAbvr: '',
            Remark: ''
        });
        setCurrentOthChrgId(null);
        setMode('view');
    };

    const handleExit = () => {
        navigate('/otherchargestable')
    }

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        let Flag = await checkAndLock(currentOthChrgId, "MstOthChrg", "OthChrgId");
        switch (Flag) {
            case 0:
                setOpenConfirmDialog(false);
                await fetchOtherCharges(currentOthChrgId, "D");
                await fetchOtherCharges(currentOthChrgId, "N");
                setStatus("1");
                setMode('view');
                setIsFormDisabled(true);
                break;
            case 1: toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default: toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    return (
        <>
            <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
                <ToastContainer />
                <Grid container spacing={2} className='form_grid'>
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'space-between', marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-previous'
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentOthChrgId || currentOthChrgId === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-next'
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentOthChrgId}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'Auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            Other Charges
                        </Typography>

                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName={"Other Charges"}
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleConfirmDelete}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className='form_field'>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4} lg={3}>
                                <TextField
                                    id="ChrgName"
                                    name="ChrgName"
                                    label={
                                        <span>
                                            Charges Name <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.ChrgName}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    error={error.ChrgName}
                                    helperText={error.ChrgName && ""}
                                    inputRef={ChrgNameRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>

                            <Grid item xs={12} md={4} lg={3}>
                                <TextField
                                    id="ChrAbvr"
                                    name="ChrAbvr"
                                    label={
                                        <span>
                                            Abrv
                                        </span>
                                    }
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.ChrAbvr}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={ChrAbvrRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>

                            <Grid item xs={12} md={4} lg={3}>
                                <TextField
                                    id="Remarks"
                                    name="Remarks"
                                    label="Remark"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Remarks}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={RemarkRef}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} lg={2}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isFormDisabled}
                                                checked={Status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label="Status"
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>

                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(DataForPrint).length > 0 &&
                    <ReportTable
                        columns={columns}
                        rows={rows}
                        title="Other Charges"
                        contentRef={contentRef}
                        customStyles={{ backgroundColor: '#f5f5f5' }}
                    />
                }
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default OtherCharges;
